<template>
    <div class="apply home_bg">
        <Header :title="title"></Header>
        <div style="width: 100%;height: 80px;"></div>
		<div class="wx_box">
		    <div class="wx_main">
		        <el-table :data="recordTableData" class="wx_table" :row-class-name="tableRowClassName">
		           <!-- <el-table-column prop="is_check" label="审核状态">
						<template slot-scope="scope">
							
						    <span v-if="scope.row.is_check===3">待审核</span>
							<span v-else-if="scope.row.is_check===2">已拒绝</span>
							<span v-else-if="scope.row.is_check===1">已审核</span>
							<span v-else>待提交</span>
						</template>
						
					</el-table-column> -->
					<el-table-column prop="created_at" label="提交时间"></el-table-column>
		            <el-table-column prop="content" label="审核内容"></el-table-column>
		            <el-table-column prop="content" label="审核时间">
						<template slot-scope="scope">
							<span v-if="scope.row.checked_at==0">-</span>
							<span v-else>{{scope.row.checked_at|formatDate}}</span>
						</template>
						
					</el-table-column>
					
		        </el-table>
		    </div>
		</div>
        <OpenSteps :isActiveNum="isActiveNum"></OpenSteps>
        <!--人员配置-->
        <div class="wx_box" v-if="isActiveNum == 1">
            <div class="wx_main">
				 <el-button class="skip marBot" @click="skipShow = true">跳过</el-button>
                <el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName">
                    <el-table-column prop="position.name" label="职位"></el-table-column>
                    <el-table-column prop="user.nickname" label="姓名"></el-table-column>
                    <el-table-column prop="user.mobile" label="账号/手机号"></el-table-column>
                    <el-table-column prop="month_salary" label="薪资"></el-table-column>
                    <el-table-column prop="Photo" label="照片" >
                        <template slot-scope="scope">
                            <img :src="scope.row.user.avatar" alt="">
                        </template>
                    </el-table-column>
          
                </el-table>
                <div class="tip_box">
                    <h5>说明：</h5>
                    <p>1、经理账号拥有园区所有栏目的浏览、查看权限，不参与任何具体事务。</p>
                    <p>2、项目主管账号拥有园区填写任务的权限，以及分派任务、发布日志等权限。</p>
                    <p>3、助理账号拥有园区填写任务的权限，以及查看任务和日志的权限，及少量板块的浏览权限。</p>
                    <p>4、当申请提交之后，平台方将为园区提供技术员账号，安排园区任务，指导园区的日常工作。</p>
                    <p>5、同一账号在一个园区内只能拥有一种职位。</p>
                    <p>6、请至少添加一个项目主管。</p>

                </div>
				<div class="btns">
				 
				    <el-button class="again" @click="isActiveNum = 2">下一步</el-button>
				</div>
            </div>
        </div>
        <!--园区详细信息-->
        <div class="wx_box" v-if="isActiveNum == 2">
			<el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="0px">
            <div class="wx_main">
                <div class="wx_detail">
                    <el-button class="skip pos" @click="skipShow = true">跳过</el-button>
                    <div class="item">
                        <span class="label">土地租金:</span>
                        <div class="input"> </div>
                        <span class="tip">{{infoForm.area_hire}}元/亩</span>
                        <i>（说明：租赁桩头则按照桩头年租金×每亩种植密度）</i>
                    </div>
                    <div class="item">
                        <span class="label">工价:</span>
                        <span class="subLabel">男工:</span>
                        <div class="input"></div>
                        <span class="tip">{{infoForm.man_salary}}人/元/天</span>
                        <span class="subLabel marL">女工:</span>
                        <div class="input"></div>
                        <span class="tip">{{infoForm.women_salary}}人/元/天</span>
                        <i>（说明：为后面计算实际人工费用时调用）</i>
                    </div>
                    <div class="item">
                        <span class="label">是否有大棚:</span>
                        <div class="input">
							<el-form-item label="" prop="is_arch">
                            <el-radio-group v-model="infoForm.is_arch">
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
							</el-form-item>
                        </div>
                    </div>
                    <div class="item">
                        <span class="label">土壤信息:</span>
                        <span class="subLabel">性状:</span>
                        <div class="input">
							<el-form-item label="" prop="soil_info">
                            <el-select v-model="infoForm.soil_info" placeholder="请选择" disabled="">
                                <el-option
                                        v-for="item in soil_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="item">
                        <span class="label">板结程度:</span>
                        <span class="subLabel">PH值:</span>
                        <div class="input" style="color: white;">
					{{infoForm.ph}}
                        </div>
                    </div>
                    <div class="noFlex">
                        <div class="label">照片:</div>
                        <div class="tips">上传园区轮廓图</div>
                        <div class="fliesed" style="background:url('') ;">
							
                     
                                <div class="positive">
                                    <img :src="infoForm.skeleton_map" v-if="skeletonMapFileList.length>0" style="width: 100%; height: 100%;">
                                </div>
							
							
                        </div>
                    </div>
					<div class="item">
							<div class="label">水源类型:</div>
							<div class="input">
								<el-form-item label="" prop="water_type">
									<el-checkbox-group v-model="infoForm.water_type" disabled>
						
										<el-checkbox :label="type.id" v-for="(type,index) in water_type_list"
											:key="type.id">{{type.name}}</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
							</div>
						</div>
					<div class="item">
						<div class="label">方量:</div>
						<div class="input">
							<el-form-item label="" prop="fang_liang">
								<el-input v-model="infoForm.fang_liang" placeholder="请输入方量" readonly=""></el-input>
							</el-form-item>
					
							
						</div>
					</div>
						<div class="item">
							<div class="label">水源:</div>
							<div class="input">
								<el-form-item label="" prop="water" >
									<el-checkbox-group v-model="infoForm.water" disabled>
										<el-checkbox :label="water.id" v-for="(water,index) in water_list"
											:key="water.id">{{water.name}}</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
							<div class="label">*稳定性:</div>
							<div class="input">
								<el-form-item label="" prop="stableness">
									<el-radio-group v-model="infoForm.stableness">
										<el-radio :label="1" disabled>稳定</el-radio>
										<el-radio :label="2" disabled>不稳定</el-radio>
									</el-radio-group>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
							<div class="label">*水质检测:</div>
							<div class="input">
								<el-form-item label="" prop="water_detect" >
									<el-radio-group v-model="infoForm.water_detect">
										<el-radio :label="1" disabled>合格</el-radio>
										<el-radio :label="2" disabled>不合格</el-radio>
									</el-radio-group>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
							<div class="label">水质问题:</div>
							<div class="input">
								<el-form-item label="" prop="water_question">
									<el-input type="textarea" v-model="infoForm.water_question"
										placeholder="请输入水质问题" disabled></el-input>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
						    <span class="label">气候:</span>
						    <span class="subLabel">年均温:</span>
						    <div class="input"><el-form-item label="" prop="year_average_temp" >
										<el-input v-model="infoForm.year_average_temp" style="width:60px;" disabled>
										</el-input>
									</el-form-item></div>
						   <span class="tip">℃</span>
						    <span class="subLabel marL">年最高温:</span>
						    <div class="input"><el-form-item label="" prop="year_high_temp">
										<el-input v-model="infoForm.year_high_temp" style="width:60px;" disabled></el-input>
									</el-form-item></div>
						    <span class="tip">℃</span>
						<span class="subLabel marL">年最低温:</span>
						<div class="input"><el-form-item label="" prop="year_high_temp">
										<el-input v-model="infoForm.year_high_temp" style="width:60px;" disabled></el-input>
									</el-form-item></div>
						<span class="tip">℃</span>
						<span class="subLabel marL">年最低温:</span>
						<div class="input"><el-form-item label="" prop="year_sunshine_amount" >
										<el-input v-model="infoForm.year_sunshine_amount" style="width:60px;" disabled>
										</el-input>
									</el-form-item></div>
						<span class="tip">小时</span>
						</div>
						
						<div class="item">
							<div class="label">年最高温发生时段:</div>
							<div class="input">
								<el-form-item label="" prop="year_high_temp_months" >
									<el-checkbox-group v-model="infoForm.year_high_temp_months" disabled>
										<el-checkbox v-for="high in 12" :label="high" :key="high">{{high}}月
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
							<div class="label">年最低温发生时段:</div>
							<div class="input">
								<el-form-item label="" prop="year_low_temp_months" >
									<el-checkbox-group v-model="infoForm.year_low_temp_months" disabled>
										<el-checkbox v-for="low in 12" :label="low" :key="low">{{low}}月
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
							<div class="label">强降雨量集中月份:</div>
							<div class="input">
								<el-form-item label="" prop="rain_months">
									<el-checkbox-group v-model="infoForm.rain_months" disabled>
						
										<el-checkbox v-for="rain in 12" :label="rain" :key="rain">{{rain}}月
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
							</div>
						</div>
						<div class="item">
							<div class="label">旱季集中月份:</div>
							<div class="input">
								<el-form-item label="" prop="han_months">
									<el-checkbox-group v-model="infoForm.han_months">
						
										<el-checkbox v-for="han in 12" :label="han" :key="han" disabled>{{han}}月
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								
							</div>
						</div>
                </div>
                <div class="btns three_btns">
                    <el-button @click="isActiveNum = 1">上一步</el-button>
              
                    <el-button @click="isActiveNum = 3">下一步</el-button>
                </div>
            </div>
			</el-form>
        </div>
        <!--作物详细信息-->
        <div class="wx_box" v-if="isActiveNum == 3">
            <div class="wx_main">
                <el-button class="skip marBot" @click="skipShow = true">跳过</el-button>
                <el-table :data="detaliTableData" class="wx_table" :row-class-name="tableRowClassName">
                    <el-table-column prop="dict_name" label="作物大类"></el-table-column>
                    <el-table-column prop="crop_name" label="品种名"></el-table-column>
                    <el-table-column prop="information" label="初始信息">
                        <template slot-scope="scope">
                            <div class="msg">
                                <div>
                                   <img :src="scope.row.all_image" alt="">
									 <p>整株</p>
									 </div>
									  <div>
                                   <img :src="scope.row.lamina_image" alt="">
								   <p>叶片</p>
								   </div>
								    <div>
								   <img :src="scope.row.branch_image" alt="">
								   <p>枝梢</p>	
															  </div>
															   <div>
								   <img :src="scope.row.fruit_image" alt="">
								   <p>果</p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
             
                </el-table>
                <div class="btns three_btns" >
                    <el-button @click="isActiveNum = 2">上一步</el-button>
                
                    <el-button @click="isActiveNum = 4">下一步</el-button>
                </div>
            </div>
        </div>
        <!--分区设置-->
        <div class="wx_box" v-if="isActiveNum == 4">
            <div class="wx_main">
                <el-button class="skip marBot" @click="skipShow = true">跳过</el-button>
                <table class="my_table">
                    <thead>
                        <tr>
                            <th width="180">分区名字</th>
                            <th width="180">分区品种</th>
                            <th>该区作物是否脱毒</th>
                            <th>作物株数</th>
                            <th>分区中心点经纬度</th>
                            <th>分区最远边距点经纬度</th>
                            <th width="270">中心点至边距点距离</th>
                       
                        </tr>
                    </thead>
                    <tbody v-for="(item,index) in partitionTableData" :key="index">
                        <tr>
                            <td>{{item.name}}</td>
                            <td>{{item.crop.name}}</td>
                            <td v-if="item.is_poison==1">是</td>
							<td v-else>否</td>
                            <td>{{item.number}}株</td>
                            <td>北纬{{item.center_lat}} ´东经{{item.center_lng}} ´</td>
                            <td>北纬{{item.side_lat}} ´东经{{item.side_lng}} ´</td>
                            <td>{{item.distance}}km</td>
                        
                        </tr>
                        <tr>
                            <td rowspan="5"></td>
                            <td>冠幅 (横泾)</td>
                            <td colspan="4">{{item.canopy_breadth}}CM</td>
                            <td></td>
                            
                        </tr>
                        <tr>
                            <td>生命周期</td>
							<td colspan="4" v-if="item.life_cycle==0">无</td>
                            <td colspan="4" v-if="item.life_cycle>0">{{item.dict.name}}</td>
                            <td></td>
                        </tr>
						<tr>
							<td>园区产果情况</td>
							<td colspan="4"><span v-if="item.type==1">投产</span><span
									v-if="item.type==2">养树</span></td>
							<td>
								
							</td>
						</tr>
                        <tr v-if="item.life_cycle>0">
                            <td>物候期</td>
                            <td colspan="4">
                                <div class="tdCell"> 
                                    <span v-for="(val,index) in item.life" :key="index">{{val.life.name}}：<em v-if="val.is_enophase=='1'">{{val.enophase.month}}月{{val.enophase.day}}日 </em></span><br>
                                 
                                </div>
                            </td>
                            <td>根据选择的生命周期，显示的 物候期信息，可改变生命周期 会得到不同的物候期配置。</td>
                        </tr>
                        <tr>
                            <td>上一季产量</td>
                            <td colspan="4">{{item.output}}斤/株</td>
                            <td ><el-button class="edit_btn" type="primary" plain size="small" @click="editYield(item)" style="display: none;">编辑</el-button></td>
                        </tr>
                        <tr>
                            <td>上一季平均售价</td>
                            <td colspan="4">{{item.average_price}}元/斤</td>
                            <td><el-button class="edit_btn" type="primary" plain size="small" @click="editPrice(item)" style="display: none;">编辑</el-button></td>
                        </tr>
   
                    </tbody>
                </table>
                <div class="btns three_btns">
                    <el-button @click="isActiveNum = 3">上一步</el-button>
          
                    <el-button @click="isActiveNum = 5">下一步</el-button>
                </div>
            </div>
        </div>
        <!--病虫害信息-->
        <div class="wx_box" v-if="isActiveNum == 5">
            <div class="wx_main">
                <el-button class="skip marBot" @click="skipShow = true">跳过</el-button>
                <table class="my_table">
                    <thead>
                        <tr>
                            <th>作物大类</th>
                            <th>病虫害名</th>
                            <th>病虫害发生次数及时间</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,indexs) in pestTableData" :key="indexs">
                            <td>{{item.insect.name}}</td>
                            <td>{{item.pest.insect_pest_name}}</td>
                            <td>
                                <p v-for="(items,inx) in item.time">第{{items.number}}次: {{items.apply_time}}</p>
                       
                            </td>
                            <td>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="btns three_btns">
                    <el-button @click="isActiveNum = 4">上一步</el-button>
                
                    <el-button @click="isActiveNum = 6">下一步</el-button>
                </div>
            </div>
        </div>
        <!--申请开通-->
        <div class="wx_box" v-if="isActiveNum == 6">
            <div class="wx_main">
				 <el-form :model="remarkForm" :rules="remarkRules" ref="remarkForm" label-width="0px">
                <div class="wx_option">
                    <h6>您的述求，开通本系统的目的是想能达到如下的意愿：</h6>
					<el-form-item label="" prop="avatar">
                    <el-checkbox-group v-model="remarkForm.remarkData">
                        <el-checkbox :label="vals.id" :key="inx+1" v-for="(vals,inx) in remark" disabled="">{{inx+1}}.{{vals.name}}。</el-checkbox> 
                        <el-checkbox :label="0" :key="0" disabled="">其他 <el-input v-model="remarkForm.word"></el-input></el-checkbox>
                    </el-checkbox-group>
						</el-form-item>
                </div>
                <div class="btns">
                    <el-button @click="isActiveNum = 5">上一步</el-button>
                    
                </div>
				</el-form>
            </div>
        </div>
		
		
        <!--点击删除弹窗-->
        <WxMessageBox :show="delShow" @save="delSave" @canse="delCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--点击确认弹窗-->
        <WxMessageBox :show="saveShow" @save="saveSave" @canse="saveCanse">
            <div slot="content">
                <div class="word">
                    <p>你是否确定本次操作！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--点击确定，相同手机号的提示弹窗-->
        <WxMessageBox :show="phoneShow" @save="phoneSave" @canse="phoneCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你添加的人员手机号，已经在该园区中，</p>
                    <p>一个园区不能有2个同样的账号！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--编辑/添加人员弹窗-->
        <WxMessageBox :show="editPersonnelShow" @save="editPersonnelSave" @canse="editPersonnelCanse">
			
            <div slot="content">
				 <el-form :model="userForm" :rules="userRules" ref="userForm" label-width="0px">
                <div class="wx_form">
					
                    <div class="wx_top">
						 <el-form-item label="" prop="avatar">
                        <el-upload
                                class="avatar-uploader"
                                 :action="uploadAction"
								 :headers="myHeaders"
								 :file-list="avatarfileList"
                                :show-file-list="false"
								
                                :on-success="handlePersonnelSuccess"
                                :before-upload="beforePersonnelUpload">
                          
							 <img :src="userForm.avatar" v-if="avatarfileList.length>0" style="width: 70px; height: 70px;">
                            <div class="unloadIcon" v-else></div>
                        </el-upload>
						</el-form-item>
						
                    </div>
					
	
                    <div class="form_item">
                        <span class="label">账号\手机号</span>
                        <div class="input">
							 <el-form-item label="" prop="mobile">
                            <el-input v-model="userForm.mobile" size="mini" :readonly="readonly"></el-input>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label">工种</span>
                        <div class="input">
							 <el-form-item label="" prop="position_code">
                            <el-select v-model="userForm.position_code" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in position_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label">姓名</span>
                        <div class="input">
							 <el-form-item label="" prop="nickname">
                            <el-input v-model="userForm.nickname" size="mini"></el-input>
							</el-form-item>
                        </div>
                    </div>

                    <div class="form_item">
                        <span class="label">薪资</span>
                        <div class="input">
							 <el-form-item label="" prop="salary">
                            <el-input class="w106" v-model="userForm.salary" size="mini" placeholder="请填数字" type="number"></el-input>
							</el-form-item>
                        </div>
                        <span class="tip">元/月</span>
                    </div>
                </div>
				</el-form>
            </div>
			
        </WxMessageBox>
        <!--点击跳过弹窗-->
        <WxMessageBox :show="skipShow" @save="skipSave" @canse="skipCanse">
            <div slot="content">
                <div class="word">
                    <p>你确定跳过此步骤么？</p>
                </div>
            </div>
        </WxMessageBox>
        <!--园区详细信息点击保存弹窗-->
        <WxMessageBox :show="detailSaveShow" @save="detailSaveSave" @canse="detailSaveCanse">
            <div slot="content">
                <div class="word">
                    <p>你已经成功保存！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--作物详细信息删除是判断弹窗-->
        <WxMessageBox :show="delJudgeShow" @save="delJudgeSave" @canse="delJudgeCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>对不起，该作物已经与分区挂钩，请先在</p>
                    <p>分区列表里面清除作物，才可以删除。</p>
                </div>
            </div>
        </WxMessageBox>
        <!--编辑/添加作物弹窗-->
        <WxMessageBox :show="editCropShow" @save="editCropSave" @canse="editCropCanse">
            <div slot="content">
				 <el-form :model="cropForm" :rules="cropRules" ref="cropForm" label-width="0px">
                <div class="wx_form">
                    <div class="form_item">
                        <span class="label">作物大类:</span>
                        <div class="input">
							<el-form-item label="" prop="dict_id">
                            <el-select v-model="cropForm.dict_id" placeholder="请选择" size="mini" @change="changeCrop">
                                <el-option
                                        v-for="item in dict_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label">品种名:</span>
                        <div class="input">
							<el-form-item label="" prop="crop_id">
                            <el-select v-model="cropForm.crop_id" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in crop_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="lable_tips">作物整株情况：<span>(请上传1张照片)</span></div>
                    <div class="wx_top">
						<el-form-item label="" prop="all_image">
                        <el-upload
                                class="avatar-uploader"
                               :action="uploadAction"
                               :headers="myHeaders"
                               :file-list="allFileList"
                                :show-file-list="false"
                                :on-success="handleCropSuccess1"
                                :before-upload="beforePersonnelUpload">
                            <img v-if="cropForm.all_image" :src="cropForm.all_image" class="avatar" style="width: 100%;height: 100%;">
                            <div class="unloadIcon" v-else ></div>
                        </el-upload>
						</el-form-item>
                    </div>
                    <div class="lable_tips">作物叶片情况：<span>(请上传1张照片)</span></div>
                    <div class="wx_top">
						<el-form-item label="" prop="lamina_image">
                        <el-upload
                                class="avatar-uploader"
                               :action="uploadAction"
                               :headers="myHeaders"
                               :file-list="laminaFileList"
                                :show-file-list="false"
                                :on-success="handleCropSuccess2"
                                :before-upload="beforePersonnelUpload">
                            <img v-if="cropForm.lamina_image" :src="cropForm.lamina_image" class="avatar" style="width: 100%;height: 100%;">
                            <div class="unloadIcon" v-else></div>
                        </el-upload>
						</el-form-item>
                    </div>
                    <div class="lable_tips">作物枝梢情况：<span>(请上传1张照片)</span></div>
                    <div class="wx_top">
						<el-form-item label="" prop="branch_image">
                        <el-upload
                                class="avatar-uploader"
                                :action="uploadAction"
                                :headers="myHeaders"
                                :file-list="branchFileList"
                                :show-file-list="false"
                                :on-success="handleCropSuccess3"
                                :before-upload="beforePersonnelUpload">
                            <img v-if="cropForm.branch_image" :src="cropForm.branch_image" class="avatar" style="width: 100%;height: 100%;">
                            <div class="unloadIcon" v-else></div>
                        </el-upload>
						</el-form-item>
                    </div>
                    <div class="lable_tips">作物果情况：<span>(请上传1张照片)</span></div>
                    <div class="wx_top">
						<el-form-item label="" prop="fruit_image">
                        <el-upload
                                class="avatar-uploader"
                                :action="uploadAction"
                                :headers="myHeaders"
                                :file-list="fruitFileList"
                                :show-file-list="false"
                                :on-success="handleCropSuccess4"
                                :before-upload="beforePersonnelUpload">
                            <img v-if="cropForm.fruit_image" :src="cropForm.fruit_image" class="avatar" style="width: 100%;height: 100%;">
                            <div class="unloadIcon" v-else></div>
                        </el-upload>
						</el-form-item>
                    </div>
                    <div class="lable_tips">请选择该作物所使用的任务策略:</div>
                    <div class="form_item" style="margin-top: 0">
                        <span class="label"></span>
                        <div class="input">
							<el-form-item label="" prop="rule_task_id">
                            <el-select v-model="cropForm.rule_task_id" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in rule_task_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--复制作物配置详情弹窗-->
        <WxMessageBox :show="copyShow" @save="copySave" @canse="copyCanse">
            <div slot="content">
				 <el-form :model="copyForm" :rules="copyRules" ref="copyForm" label-width="0px">
                <div class="copyDetail marTop44">
                    <p>根据您的分区作物品种，筛选出如下几个相同作物品种的分区，您可以从中选择出您需要复制的分区作物配置详情： </p>
                    <div class="form_item">
                        <span class="lable">分区品种:</span>
                        <div class="input">
							<el-form-item label="" prop="copy_to_id">
                            <el-select v-model="copyForm.copy_to_id" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in partition_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <p>重要提示：当您点击确定之后，该区现有作物配置详情将会被您选择的分区的作物详情覆盖，如果您已经有编辑的内容，将无法恢复，请谨慎操作！ </p>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--添加分区弹窗-->
        <WxMessageBox :show="addPartitionShow" :width="addPartitionWidth" @save="addPartitionSave" @canse="addPartitionCanse">
            <div slot="content">
				 <el-form :model="partitionForm" :rules="partitionRules" ref="partitionForm" label-width="0px">
                <div class="addPartition">
                    <div class="form_item">
                        <span class="lable">分区名称:</span>
                        <div class="input">
							<el-form-item label="" prop="name">
                            <el-input v-model="partitionForm.name" placeholder="限定5个字" maxlength="5" size="mini"></el-input>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="lable">分区品种:</span>
                        <div class="input">
							<el-form-item label="" prop="crop_id">
                            <el-select v-model="partitionForm.crop_id" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in detaliTableData"
                                        :key="item.crop_id"
                                        :label="item.crop_name"
                                        :value="item.crop_id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                        <div class="label_tips">提示: <span>一个分区仅一类品种</span></div>
                    </div>
                    <div class="form_item">
                        <span class="lable">该作物是否脱毒:</span>
                        <div class="input">
							<el-form-item label="" prop="is_poison">
                            <el-radio-group v-model="partitionForm.is_poison">
                                <el-radio :label="1">是</el-radio>
                                <el-radio :label="2">否</el-radio>
                            </el-radio-group>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="lable">作物株数:</span>
                        <div class="input">
							<el-form-item label="" prop="number">
                            <el-input v-model="partitionForm.number" placeholder="填写数字" size="mini"></el-input>
							</el-form-item>
                        </div>
                        <div class="label_tips">株</div>
                    </div>
                    <div class="form_item">
                        <span class="lable">分区中心点经纬度:</span>
                        <span class="subLabel">北纬</span>
                        <div class="input w60">
							<el-form-item label="" prop="center_lat">
                            <el-input v-model="partitionForm.center_lat" placeholder="数字" size="mini"  style="width: 120px;"></el-input>
							</el-form-item>
                        </div>
                        <span class="subLabel paddL">东经</span>
                        <div class="input w60">
							<el-form-item label="" prop="center_lng">
                            <el-input v-model="partitionForm.center_lng" placeholder="数字" size="mini" style="width: 120px;"></el-input>
							</el-form-item>
                        </div>
                      
                    </div>
                    <div class="form_item">
                        <span class="lable">分区最远边距点经纬度:</span>
                        <span class="subLabel">北纬</span>
                        <div class="input w60">
							<el-form-item label="" prop="side_lat">
                            <el-input v-model="partitionForm.side_lat" placeholder="数字" size="mini" style="width: 120px;"></el-input>
							</el-form-item>
                        </div>
           
                        <span class="subLabel paddL">东经</span>
                        <div class="input w60">
							<el-form-item label="" prop="side_lng">
                            <el-input v-model="partitionForm.side_lng" placeholder="数字" size="mini" style="width: 120px;"></el-input>
							</el-form-item>
							
                        </div>
                      
                    </div>
                    <div class="bot_tips">
                        提示：经纬度后一个空请填入4位数字，带小数点。如：55.43
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
		<!--编辑冠幅-->
		<WxMessageBox :show="editTimeShow" @save="editTimeSave" @canse="editTimeCanse">
		    <div slot="content">
				<el-form :model="timeForm" :rules="timeRules" ref="timeForm" label-width="0px">
		        <div class="edit_box">
		            <div class="form_item">
		                <span class="lable">月份:</span>
		                <div class="input">
								<el-form-item label="" prop="month">
		                    <el-select v-model="timeForm.month" placeholder="请选择" size="mini">
		                        <el-option
		                                v-for="item in 12"
		                                :key="item"
		                                :label="item"
		                                :value="item">
		                        </el-option>
		                    </el-select>
							</el-form-item>
		                </div>
		                <div class="label_tips">月</div>
		            </div>
					<div class="form_item">
					    <span class="lable">日期:</span>
					    <div class="input">
								<el-form-item label="" prop="day">
					     <el-select v-model="timeForm.day" placeholder="请选择" size="mini">
					         <el-option
					                 v-for="item in 31"
					                 :key="item"
					                 :label="item"
					                 :value="item">
					         </el-option>
					     </el-select>
							</el-form-item>
					    </div>
					    <div class="label_tips">日</div>
					</div>
		        </div>
				</el-form>
		    </div>
		</WxMessageBox>
        <!--编辑冠幅-->
        <WxMessageBox :show="editCrownShow" @save="editCrownSave" @canse="editCrownCanse">
            <div slot="content">
				<el-form :model="canopyForm" :rules="canopyRules" ref="canopyForm" label-width="0px">
                <div class="edit_box">
                    <div class="form_item">
                        <span class="lable">请输入横泾:</span>
                        <div class="input">
								<el-form-item label="" prop="canopy_breadth">
                            <el-input v-model="canopyForm.canopy_breadth" size="mini"></el-input>
							</el-form-item>
                        </div>
                        <div class="label_tips">CM</div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--编辑产量-->
        <WxMessageBox :show="editYieldShow" @save="editYieldSave" @canse="editYieldCanse">
            <div slot="content">
				<el-form :model="outputForm" :rules="outputRules" ref="outputForm" label-width="0px">
                <div class="edit_box">
                    <div class="form_item">
                        <span class="lable">请输入</span>
                        <div class="input">
							<el-form-item label="" prop="output">
                            <el-input v-model="outputForm.output" size="mini"></el-input>
							</el-form-item>
                        </div>
                        <div class="label_tips">斤/株</div>
                    </div>
                </div>
					</el-form>
            </div>
        </WxMessageBox>
        <!--编辑平均售价-->
        <WxMessageBox :show="editPriceShow" @save="editPriceSave" @canse="editPriceCanse">
            <div slot="content">
				<el-form :model="priceForm" :rules="priceRules" ref="priceForm" label-width="0px">
                <div class="edit_box">
                    <div class="form_item">
                        <span class="lable">请输入</span>
                        <div class="input">
							<el-form-item label="" prop="average_price">
                            <el-input v-model="priceForm.average_price" size="mini"></el-input>
							</el-form-item>
							
                        </div>
                        <div class="label_tips">元/斤</div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--编辑生命周期-->
        <WxMessageBox :show="editCycleShow" @save="editCycleSave" @canse="editCycleCanse">
            <div slot="content">
				<el-form :model="lifeForm" :rules="lifeRules" ref="lifeForm" label-width="0px">
                <div class="cycle_box">
                    <div class="label">请选择:</div>
					<el-form-item label="" prop="life_cycle">
                    <el-radio-group v-model="lifeForm.life_cycle">
                        <el-radio :label="val.id" v-for="(val,ind) in life_list" :key="ind">{{val.name}}</el-radio>
                     
                    </el-radio-group>
					</el-form-item>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--添加病虫危害信息-->
        <WxMessageBox :show="pestDamageShow" @save="pestDamageSave" @canse="pestDamageCanse">
            <div slot="content">
				<el-form :model="pestForm" :rules="pestRules" ref="pestForm" label-width="0px">
                <div class="pestDamage">
                    <div class="form_item">
                        <span class="label">选择作物大类:</span>
                        <div class="input">
							<el-form-item label="" prop="dict_id">
                            <el-select v-model="pestForm.dict_id" placeholder="请选择" size="mini" @change="getDataPest">
                                <el-option
                                        v-for="item in dict_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label">选择病虫灾害名:</span>
                        <div class="input">
							<el-form-item label="" prop="insect_pest_id">
                            <el-select v-model="pestForm.insect_pest_id" placeholder="请选择" size="mini">
                                <el-option
                                        v-for="item in pest_list"
                                        :key="item.id"
                                        :label="item.insect_pest_name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="label w266">病虫害发生次数及时间：</span>
                        <span class="addBtn" @click="addNum">添加次数</span>
                    </div>
                    <div class="form_item" v-for="(item,index) in pestForm.timeData">
                        <span class="label">第{{index+1}}次:</span>
                        <div class="input">
                            <el-date-picker
                                    v-model="item.name"
                                    type="date"
                                    size="mini"
									value-format="yyyy-MM-dd"
                                    placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
     
    </div>
</template>

<script>
	import {getFarmInfo,createFarmUser,deleteFarmOther,saveFarmDetail,get_data_crop,saveFarmCrop,saveFarmPartition,saveFarmAreaField,saveFarmAreaEnophase,getFarmSameCrop,copyFarmPartition,getDataPest,saveFarmInsectPest,saveFarmRemark} from '@/api/api'
		 import axios from 'axios';
		 import {formatDate} from '../../../js/common.js';
    import Header from '@/components/Header';
    import OpenSteps from '@/components/OpenSteps';
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "applyOpen",
        data(){
			  var validatePass = (rule, value, callback) => {
			      // if (value <= 0) {
			      //   callback(new Error('请输入大于0的整数'));
			      // } else {
			      //   callback();
			      // }
			      if (Number.isInteger(Number(value)) && Number(value) > 0) {
			        callback();
			      } else {
			        callback(new Error('请输入大于0的整数'));
			      }
			    }
				
            return {
				//通用
				title:"dadada",
				recordTableData:[],
				delete_controller:'',
				delete_action:'',
				delete_id:'',
                addPartitionWidth:'724px',
                isActiveNum: 1,
				farm_id:'',
				uploadAction:axios.defaults.baseURL+"/upload/image",
				myHeaders: {
				         authorization: "Bear "+localStorage.getItem("token")
				       },
					   
				//下面是添加管理人员
				readonly:false,	   
                tableData: [],
				position_list:[],
				avatarfileList:[],
				userForm:{ 
					       id:'',
					       mobile:'',
						   nickname:'',
						   avatar:'',
						   position_code:'',
						   salary:'',	   
				},
				userRules: {					
					mobile: [{required: true,message: '请输入手机号码',trigger: 'blur'},
					         { pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
					        ],
				    nickname: [{required: true,message: '请输入姓名',trigger: 'blur'}
							  ],
					// avatar: [{required: true,message: '请上传头像',trigger: 'blur'}
					// 		],
					/* password: [{required: true,message: '请输入密码',trigger: 'change'},
					           {min: 8,max: 16,message: '必须是8-16位',trigger: 'blur'}
							  ], */
					position_code: [{required: true,message: '请选择职位',trigger: 'change'}
							       ],
					salary: [{required: true,message: '请输入工资',trigger: 'change'}
							],						
				},
				//下面是园区基础信息
				skeletonMapFileList:[],
				soil_list:[],
				infoForm:{					
					       id:'',
					       area_hire:'',
						   man_salary:'',
						   women_salary:'',
						   is_arch:1,
						   ph:'',
						   soil_info:'',
						   skeleton_map:'',
                           water: [],
						   water_type: [],
						   fang_liang: '',
						   stableness: '',
						   water_detect: '',
						   water_question: '',
						   year_average_temp: '',
						   year_high_temp: '',
							year_low_temp: '',
							year_sunshine_amount: '',
							year_high_temp_months: [],
							year_low_temp_months: [],
							rain_months: [],
							han_months: [],							   						 
				},
				infoRules: {
					area_hire: [{required: true,message: '请输入租金',trigger: 'blur'}
					        ],
				    man_salary: [{required: true,message: '请输入男工工资',trigger: 'blur'}
							  ],
					 women_salary: [{required: true,message: '请输入女工工资',trigger: 'blur'}
						],
					 ph: [{required: true,message: '请输入ph值',trigger: 'change'}
							  ], 
					soil_info: [{required: true,message: '请选择土壤信息',trigger: 'change'}
							       ],
					skeleton_map: [{required: true,message: '请上传轮廓图',trigger: 'blur'}
							],						
				},
				
				//下面是园区农作物
				dict_list:[],
				crop_list:[],
				rule_task_list:[],
				detaliTableData: [],
				allFileList:[],
				laminaFileList:[],
				branchFileList:[],
				fruitFileList:[],
				cropForm:{
					       id:'',
					       crop_id:'',
						   dict_id:'',
						   all_image:'',
						   lamina_image:'',
						   branch_image:'',
						   fruit_image:'',
						   rule_task_id:''						  
				},
				cropRules: {
					dict_id: [{required: true,message: '请选择农作物大类',trigger: 'change'}
					        ],
				    crop_id: [{required: true,message: '请选择农作物',trigger: 'change'}
							  ],
					all_image: [{required: true,message: '请上传整株情况',trigger: 'blur'}
						],
					lamina_image: [{required: true,message: '请上传叶片情况',trigger: 'blur'}
							  ], 
					branch_mage: [{required: true,message: '请选择枝梢情况',trigger: 'blur'}
							       ],
					fruit_image: [{required: true,message: '请上传果情况',trigger: 'blur'}
							],	
					rule_task_id: [{required: true,message: '请选择任务策略',trigger: 'blur'}
							],													
				},
				
				//分区信息
				partitionTableData:[],
				partitionForm:{
					       id:'',
						   name:'', 
					       crop_id:'',
						   is_poison:'',
						   number:'',
						   center_lat:'',
						   center_lng:'',
						   side_lat:'',
						   side_lng:''							 
				},
				partitionRules: {
					name: [{required: true,message: '请输入分区名称',trigger: 'blur'}
					        ],
				    crop_id: [{required: true,message: '请选择农作物',trigger: 'change'}
							  ],
					number: [{required: true,message: '请输入整株数量',trigger: 'blur'}
						],
					is_poison: [{required: true,message: '请选择是否脱毒',trigger: 'change'}
						],
					center_lat: [{required: true,message: '必填',trigger: 'blur'}
							  ], 

					center_lng: [{required: true,message: '必填',trigger: 'blur'}
							],	
					side_lat: [{required: true,message: '必填',trigger: 'blur'}
							],	
		
					side_lng: [{required: true,message: '必填',trigger: 'blur'}
							],																					
				},
				//修改价格
				priceForm:{
					       id:'',
						   average_price:'', 							 
				},
				priceRules: {
					average_price: [{required: true,message: '请输入上一季平均售价',trigger: 'blur'}
					        ],																				
				},
				//产量
				outputForm:{
					       id:'',
						   output:'', 							 
				},
				outputRules: {
					output: [{required: true,message: '请输入产量',trigger: 'blur'}
					        ],																				
				},
				//冠幅
				canopyForm:{
					       id:'',
						   canopy_breadth:'', 							 
				},
				canopyRules: {
					canopy_breadth:[{required: true,message: '请输入冠幅大小',trigger: 'blur'}],																				
				},
				
				//生命周期
				life_list:[],
				lifeForm:{
					       id:'',
						   life_cycle:'', 							 
				},
				lifeRules: {
					life_cycle:[{required: true,validator:validatePass,message: '请选择生命周期',trigger: 'blur'}],																				
				},
				
				//修改生命周期
				timeForm:{
					       id:'',
						   farm_id:'',
						   dict_id:'',
						   area_id:'',
						   month:'',
						   day:""
				},
				timeRules: {
					month:[{required: true,message: '请选择月份',trigger: 'blur'}],	
					day:[{required: true,message: '请选择日期',trigger: 'blur'}],	
				},
				//复制
				partition_list:[],
				copyForm:{
						   area_id:'',
                           copy_to_id:''
				},
				copyRules: {
					copy_to_id:[{required: true,message: '请选择目标分区',trigger: 'blur'}],	
				},
				//病虫害
				pest_list:[],
				pestTableData:[],
				pestForm:{
					       id:'',
						   insect_pest_id:'',
				           dict_id:'',
						   timeData:[],
				},
				pestRules: {
					dict_id:[{required: true,message: '请选择作物大类',trigger: 'onchange'}],	
					insect_pest_id:[{required: true,message: '请选择病虫害',trigger: 'onchange'}],
				},
				//开通意愿
				remark:[],
				remarkForm:{
					       is_check:'0',
						   word:'',
						   remarkData:[],
				},
				remarkRules: {
					remarkData:[{required: true,message: '请选择作物大类',trigger: 'onchange'}]
				},
				
				
				
                rent: '',
                maleWorker: '',
                womenWorker: '',
                phVal: '',
                radio: 1,
                character: '',
                characterOptions: [{id: '0', value: '后台字典项'}],
                imgUrl: '',
                fileList: [],
                
                checkedData:[],
                otherWord:'',
                delShow:false,
                saveShow:false,
                phoneShow:false,
                editPersonnelShow:false,
                skipShow:false,
                detailSaveShow:false,
                delJudgeShow:false,
                editCropShow:false,
                copyShow:false,
                addPartitionShow:false,
                editCrownShow:false,
                editYieldShow:false,
                editPriceShow:false,
                editCycleShow:false,
                pestDamageShow:false,
                editTimeShow:false,

            
          
                regionalVarieties:'',
                regionalVarietiesOptions:[
                    {id:'1',value:'相同品种的分区列表'}
                ],
                regionalVarieties2:'',
                regionalVarietiesOptions2:[
                    {id:'1',value:'相同品种的分区列表'}
                ],
                regionalName:'',
                radio1:1,
                numberTrees:'',
                coreNorth1:'',
                coreNorth2:'',
                coreEast1:'',
                coreEast2:'',
                hengjing:'',
                yield:'',
                price:'',
                cycle:3,
                pestDamageForm:{
                    cropCategories:'',
                    name:''
                },
                sendFormData:[],
                cropUrl1:'',
                cropUrl2:'',
                cropUrl3:'',
                cropUrl4:'',
            }
        },
		mounted() {
			this.farm_id=this.$route.params.id
			this.get_farm_info(this.$route.params.id)
		},
		filters: {
		   formatDate(time) {
		     // 秒处理为毫秒
		     time = time * 1000
		     let date = new Date(time)
		     console.log(new Date(time))
		     return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		   },
		 },
        methods:{
			changeCrop(val,type=0) {
			    get_data_crop(val).then(res => {
				if(type==0){
			      this.cropForm.crop_id=''
					}
			      this.crop_list = res
				  
			    })
			  },
			  
			  
			 getDataPest(val) {
			     getDataPest(val).then(res => {		 	
			       this.pest_list = res
			     })
			   }, 
			//获取农场相关信息
			get_farm_info(farm_id){
			getFarmInfo(farm_id).then(resp=>{
								  this.title=resp.farm.name
								  this.tableData=resp.user
								  this.detaliTableData=resp.crop
								  this.rule_task_list=resp.task
								  this.dict_list=resp.dict
								  this.position_list=resp.position
								  this.soil_list=resp.soil
								  this.partitionTableData=resp.partition
								  this.life_list=resp.life
								  this.pestTableData=resp.pest
								  this.remark=resp.remark
								  this.remarkForm["remarkData"]=resp.remark_list
								  this.remarkForm["word"]=resp.word
								   this.recordTableData=resp.check_record
								  
								  if(resp.info==null){
									  
								  } else{
								  this.infoForm.water_type=resp.farm.water_type
								  this.infoForm["fang_liang"]=resp.farm.fang_liang
								  this.infoForm.water=resp.farm.water
								  this.infoForm.stableness=resp.farm.stableness
								  this.infoForm.water_detect=resp.farm.water_detect
								  this.infoForm.water_question=resp.farm.water_question
								  this.infoForm.year_average_temp=resp.farm.year_average_temp
								   this.infoForm.year_high_temp=resp.farm.year_high_temp
								    this.infoForm.year_low_temp=resp.farm.year_low_temp
								  									 this.infoForm.year_sunshine_amount=resp.farm.year_sunshine_amount
								  									  this.infoForm.year_high_temp_months=resp.farm.year_high_temp_months
								  									  this.infoForm.year_low_temp_months=resp.farm.year_low_temp_months
								  									  this.infoForm.rain_months=resp.farm.rain_months
								  									  this.infoForm.han_months=resp.farm.han_months
								  								
								  this.skeletonMapFileList.push({path:resp.info.skeleton_map})
								   this.infoForm.area_hire=resp.info.area_hire
								   this.infoForm.man_salary=resp.info.man_salary
								   this.infoForm.women_salary=resp.info.women_salary
								   this.infoForm.ph=resp.info.ph
								   this.infoForm.is_arch=resp.info.is_arch
								   this.infoForm.soil_info=resp.info.soil_info
								   this.infoForm.area_hire=resp.info.area_hire
								  }
			})
			},
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            },
  
			deleteData(id,type){
				//删除农场相关人员
				if(type==1){
					this.delete_controller="farm_user"
					this.delete_action="delete_farm_user"
				}
				if(type==2){
					this.delete_controller="farm_crop"
					this.delete_action="delete_farm_crop"
				}
				if(type==3){
					this.delete_controller="farm_area"
					this.delete_action="delete_farm_area"
				}
				
				if(type==4){
					this.delete_controller="farm_insect_pest"
					this.delete_action="delete_farm_insect_pest"
				}
				this.delete_id=id;
				this.delShow=true
			},
            // 点击删除弹窗确定
            delSave(){
                this.delShow = false
                this.$nextTick(()=>{
                    this.saveShow = true
                })
            },
            // 点击删除弹窗取消
            delCanse(){
                this.delShow = false
            },
            // 点击确认弹窗
            saveSave(){
			deleteFarmOther(this.delete_id,this.delete_controller,this.delete_action).then(resp=>{
				
					 console.log("dadada")
					// this.$message.success(resp.msg)
					 this.saveShow = false
				
				 this.get_farm_info(this.farm_id)
				
			})
                
            },
            // 点击确认弹窗
            saveCanse(){
                this.saveShow = false
            },
            // 点击确定，相同手机号的提示弹窗确定
            phoneSave(){
                this.phoneShow = false
            },
            // 点击确定，相同手机号的提示弹窗取消
            phoneCanse(){
                this.phoneShow = false
            },
            // 编辑/添加人员弹窗确认
            editPersonnelSave(){
				this.$refs["userForm"].validate((valid) => {
					if (valid) {
				
						 createFarmUser(this.farm_id,this.userForm).then(resp=>{
							if(resp.status==1){								
                              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)
							  this.editPersonnelShow = false	
																			
													
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
			
			editPerson(row){
				
				this.readonly=true
				this.userForm["id"]=row.id
				this.userForm["avatar"]=row.user.avatar
				this.userForm["mobile"]=row.user.mobile,
				this.userForm["nickname"]=row.user.nickname,
				this.userForm["salary"]=row.month_salary
				this.userForm["position_code"]=row.position_code
				 this.avatarfileList.push(row.user.avatar)
				 this.editPersonnelShow=true
			},
            // 编辑/添加人员弹窗取消
            editPersonnelCanse(){
                this.editPersonnelShow = false
            },
            handlePersonnelSuccess(res, file) {
                this.PersonnelUrl = URL.createObjectURL(file.raw);
				this.userForm["avatar"]=res.data;
				 this.avatarfileList.push(res.data)
            },
            // 编辑、添加人员上传
            beforePersonnelUpload(file) {
               const isJPG = file.type === 'image/jpeg';
                const isPng = file.type === 'image/png';
				 const isLt2M = file.size / 1024 / 1024 < 2;
				 if (!isLt2M) {
				     this.$message.error('上传头像图片大小不能超过 2MB!');
				 }
                if (!isJPG && !isPng) {
					
                    this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
                   return false
               }else{
                 	return true
               }
              
            },
            // 点击跳过弹窗确认
            skipSave(){
                this.skipShow = false
                this.$nextTick(()=>{
                    this.isActiveNum = this.isActiveNum + 1
                })
            },
            // 点击跳过弹窗取消
            skipCanse(){
                this.skipShow = false
            },
            // 园区详细信息点击保存弹窗确认
            detailSaveSave(){
                this.detailSaveShow = false
            },
            // 园区详细信息点击保存弹窗取消
            detailSaveCanse(){
                this.detailSaveShow = false
            },
			
					// 上传园区轮廓图
			handleSkeletonMapSuccess(res, file) {
		
				this.infoForm["skeleton_map"]=res.data;
				 this.skeletonMapFileList.push(res.data)
			},
			beforeUpload(file) {
			   const isJPG = file.type === 'image/jpeg';
			    const isPng = file.type === 'image/png';
			   				 const isLt2M = file.size / 1024 / 1024 < 2;
			   				 if (!isLt2M) {
			   				     this.$message.error('上传头像图片大小不能超过 2MB!');
			   				 }
			    if (!isJPG && !isPng) {
			   					
			        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
			       return false
			   }else{
			     	return true
			   }
			                 
			},
			
			saveFarmRemark(type){
				if(type==2){
				   this.remarkForm["is_check"]=1;
				}
				this.$refs["remarkForm"].validate((valid) => {
					if (valid) {
				
						 saveFarmRemark(this.farm_id,this.remarkForm).then(resp=>{
							if(resp.status==1){								
				             // this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)
							  if(type==1){
							  this.detailSaveShow = true
							  }else{
								 this.$router.push("/park/detail/"+this.farm_id)
							  }
																			
													
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			saveFarmDetail(relFrom,type){
				console.log(relFrom);
				this.$refs[relFrom].validate((valid) => {
					if (valid) {
				
						 saveFarmDetail(this.farm_id,this.infoForm).then(resp=>{
							if(resp.status==1){								
				             // this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)
							  if(type==1){
							  this.detailSaveShow = true
							  }else{
								  this.isActiveNum=3;
							  }
																			
													
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			
            // 作物详细信息删除是判断弹窗确认
            delJudgeSave(){
                this.delJudgeShow = false
            },
            // 作物详细信息删除是判断弹窗取消
            delJudgeCanse(){
                this.delJudgeShow = false
            },
            // 编辑/添加作物弹窗确认
            editCropSave(){
				this.$refs["cropForm"].validate((valid) => {
					if (valid) {				
						 saveFarmCrop(this.farm_id,this.cropForm).then(resp=>{
							if(resp.status==1){								
				             // this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)							
							  this.editCropShow = false							  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
            // 编辑/添加作物弹窗取消
            editCropCanse(){
                this.editCropShow = false
            },
			editCrop(row){
				
				this.changeCrop(row.dict_id,1)
				this.cropForm=row
				console.log(row)
			    this.allFileList.push(row.all_image)
				this.laminaFileList.push(row.lamina_image)
				this.branchFileList.push(row.branch_mage)
				this.fruitFileList.push(row.fruit_image)
				
				this.editCropShow=true
			},
            handleCropSuccess1(res, file) {
                //this.cropUrl1 = URL.createObjectURL(file.raw);
				this.cropForm["all_image"]=res.data
            },
            handleCropSuccess2(res, file) {
               // this.cropUrl2 = URL.createObjectURL(file.raw);
			   this.cropForm["lamina_image"]=res.data
            },
            handleCropSuccess3(res, file) {
                //this.cropUrl3 = URL.createObjectURL(file.raw);
				this.cropForm["branch_mage"]=res.data
            },
            handleCropSuccess4(res, file) {
               // this.cropUrl4 = URL.createObjectURL(file.raw);
			   this.cropForm["fruit_image"]=res.data
            },
			
			copy(row){
				this.copyForm["area_id"]=row.id
				getFarmSameCrop(row.id).then(resp=>{
					this.partition_list=resp
					 this.copyShow=true
				})
			},
            // 复制作物配置详情弹窗确认
            copySave(row){
                this.$refs["copyForm"].validate((valid) => {
                	if (valid) {				
                		 copyFarmPartition(this.copyForm).then(resp=>{
                			if(resp.status==1){								
                              this.$message.success(resp.msg);
                			  this.get_farm_info(this.farm_id)	
                			   this.copyShow = false			  				  																															
                			}else{
                				this.$message.error(resp.msg);
                			}
                			}).catch(error=>console.log(error))
                	} else {
                		console.log('error submit!!');
                		return false;
                	}
                });
            },
            // 复制作物配置详情弹窗取消
            copyCanse(){
                this.copyShow = false
            },
            // 添加分区弹窗确认
            addPartitionSave(){
				this.$refs["partitionForm"].validate((valid) => {
					if (valid) {				
						 saveFarmPartition(this.farm_id,this.partitionForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							  this.addPartitionShow = false				  				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
			editPartition(row){
				
				this.partitionForm["id"]=row.id
				this.partitionForm["name"]=row.name
				this.partitionForm["crop_id"]=row.crop_id
				this.partitionForm["is_poison"]=row.is_poison,
				this.partitionForm["number"]=row.number,
				this.partitionForm["center_lat"]=row.center_lat
				 this.partitionForm["center_lng"]=row.center_lng
				 this.partitionForm["side_lat"]=row.side_lat
				  this.partitionForm["side_lng"]=row.side_lng
				 this.addPartitionShow=true
			},
			editPrice(row){
				this.priceForm["id"]=row.id
				 this.priceForm["average_price"]=row.average_price
				 this.editPriceShow=true
			},
            // 添加分区弹窗取消
            addPartitionCanse(){
                this.addPartitionShow = false
            },
			
			editCrown(row){
				this.canopyForm["id"]=row.id
				 this.canopyForm["canopy_breadth"]=row.canopy_breadth
				 this.editCrownShow=true
				 
				 console.log(this.canopyForm)
			},
            // 编辑冠幅弹窗确认
            editCrownSave(){
				this.$refs["canopyForm"].validate((valid) => {
					if (valid) {				
						 saveFarmAreaField(this.canopyForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							  this.editCrownShow = false			  				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
               
            },
            // 编辑冠幅弹窗取消
            editCrownCanse(){
                this.editCrownShow = false
            },
			
			editYield(row){
				this.outputForm["id"]=row.id
				 this.outputForm["output"]=row.output
				 this.editYieldShow=true
			},
            // 编辑产量弹窗确认
            editYieldSave(){
				
				this.$refs["outputForm"].validate((valid) => {
					if (valid) {				
						 saveFarmAreaField(this.outputForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							  this.editYieldShow = false			  				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
                
            },
            // 编辑产量幅弹窗取消
            editYieldCanse(){
                this.editYieldShow = false
            },
            // 编辑平均售价弹窗确认
            editPriceSave(){
				this.$refs["priceForm"].validate((valid) => {
					if (valid) {				
						 saveFarmAreaField(this.priceForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							  this.editPriceShow = false			  				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
            // 编辑平均售价弹窗取消
            editPriceCanse(){
                this.editPriceShow = false
            },
			editCycle(row){
				this.lifeForm["id"]=row.id
				 this.lifeForm["life_cycle"]=row.life_cycle
				 this.editCycleShow=true
			},
            // 编辑生命周期弹窗确认
            editCycleSave(){
				this.$refs["lifeForm"].validate((valid) => {
					if (valid) {				
						 saveFarmAreaField(this.lifeForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							   this.editCycleShow = false			  				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				
               
            },
            // 编辑生命周期弹窗取消
            editCycleCanse(){
                this.editCycleShow = false
            },
            // 添加病虫危害信息弹窗确认
            pestDamageSave(){
				console.log(this.pestForm)
				this.$refs["pestForm"].validate((valid) => {
					if (valid) {				
						 saveFarmInsectPest(this.farm_id,this.pestForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							   this.pestDamageShow = false		  				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
               
            },
			editPest(row){
				
				console.log(row)
				 
				
			
				 getDataPest(row.dict_id).then(res => {
				   this.pest_list = res
				   this.pestForm["id"]=row.id
				    this.pestForm["dict_id"]=row.dict_id
				    this.pestForm["insect_pest_id"]=row.insect_pest_id
				    this.pestForm["timeData"]=row.time
				    this.pestDamageShow=true
				 })
				
			},
			// 表格斑马纹
			tableRowClassName({row, rowIndex}) {
			    if (rowIndex % 2 !== 1) {
			        return 'single-row';
			    }else{
			        return 'double-row';
			    }
			},
            // 添加病虫危害信息弹窗取消
            pestDamageCanse(){
                this.pestDamageShow = false
            },
            // 添加次数
            addNum(){
                if (this.pestForm["timeData"].length > 4) {
                    this.$message.error('病虫害发生次数及时间最多为5个');
                } else {
                    this.pestForm["timeData"].push({});
                }

            },
			editTime(row,val){
				this.timeForm["farm_id"]=row.farm_id;
				this.timeForm["area_id"]=row.id;
				this.timeForm["dict_id"]=val.enophase_dict_id;
				if(val.is_enophase==1){
				this.timeForm["id"]=val.enophase.id
				this.timeForm["month"]=val.enophase.month;
				this.timeForm["day"]=val.enophase.day;
				}
				this.editTimeShow = true
			},
            // 编辑日期弹窗确认
            editTimeSave(){
				console.log(this.timeForm)
				
				this.$refs["timeForm"].validate((valid) => {
					if (valid) {				
						 saveFarmAreaEnophase(this.timeForm).then(resp=>{
							if(resp.status==1){								
				              this.$message.success(resp.msg);
							  this.get_farm_info(this.farm_id)	
							     this.editTimeShow = false 				  																															
							}else{
								this.$message.error(resp.msg);
							}
							}).catch(error=>console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
              
            },
            // 编辑日期弹窗取消
            editTimeCanse(){
                this.editTimeShow = false
            },
        },
        components: {
            Header,
            OpenSteps,
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .apply{
        .wx_box{
            .wx_main{
                padding: 42px 35px 56px 24px;
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                .skip{
                    width: 150px;
                    height: 40px;
                    line-height: 40px;
                    border: 1px solid #2D99FF;
                    padding: 0;
                    background-color: transparent;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 400;
                    color: #2D99FF;
                }
                .wx_table{
                    margin-top: 25px;
                    .cell{
                        img{
                            width: 66px;
                            height: 36px;
                        }
                    }
                    .msg{
                        display: flex;
                        justify-content: center;
                        div{
                            &+div{
                                margin-left: 20px;
                            }
                            p{
                                font-size: 12px;
                                font-weight: 500;
                                color: #C7D7DE;
                                line-height: 17px;
                            }
                        }
                    }
                }
                .tip_box{
                    padding-top: 17px;
                    h5{
                        font-size: 18px;
                        font-weight: 500;
                        color: #C7D7DE;
                        line-height: 30px;
                    }
                    p{
                        font-size: 18px;
                        font-weight: 500;
                        color: #C7D7DE;
                        line-height: 30px;
                    }
                }
                .btns{
                    width: 1000px;
                    padding-top: 55px;
                    display: flex;
                    justify-content: space-between;
                    margin: 0 auto;
                    .el-button{
                        width: 480px;
                        height: 48px;
                        background: #2D99FF;
                        font-size: 18px;
                        font-weight: 400;
                        color: #fff;
                        border: 0;
                        border-radius: 0;
                    }
                    .again{
                        background: #00A1E6;
                    }
                }
                .wx_detail{
                    padding-left: 25%;
                    position: relative;
                    .item{
                        display: flex;
                        align-items: center;
                        margin-bottom: 24px;
                        .label{
                            width: 136px;
                            font-size: 18px;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                        .subLabel{
                            width: 55px;
                            font-size: 18px;
                            font-weight: 400;
                            color: #D6D6D6;
                            padding-right: 7px;
                        }
                        .marL{
                            margin-left: 28px;
                        }
                        .input{
							
							.w90{
							    width: 90px;
							}
                            .w181{
                                width: 181px;
                            }
                            .w126{
                                width: 126px;
                            }
                            .w206{
                                width: 206px;
                            }
                            .el-select{
                                width: 206px;
                            }
                        }
                        .tip{
                            font-size: 18px;
                            font-weight: 400;
                            color: #FFFFFF;
                            padding: 0 14px 0 18px;
                        }
                        i{
                            font-size: 16px;
                            font-weight: 400;
                            color: #B7BCCB;
                        }
                    }
                    .noFlex{
                        .label{
                            font-size: 18px;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                        .tips{
                            font-size: 18px;
                            font-weight: 400;
                            color: #D6D6D6;
                            padding : 12px 0 18px 0;
                        }
                        .flies{
                            width: 400px;
                            height: 180px;
                            .positive{
                                width: 400px;
                                height: 180px;
                                background: rgba(45, 153, 255, 0.3);
                                position: relative;
                                &:before{
                                    content: '';
                                    width: 70px;
                                    height: 65px;
                                    background: url("../../../assets/images/upLoad_04.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -35px;
                                    margin-top: -32.5px;
                                    z-index: 1;
                                }
                                &:after{
                                    content: '';
                                    width: 41px;
                                    height: 41px;
                                    background: url("../../../assets/images/upLoad_02.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -20.5px;
                                    margin-top: -20.5px;
                                    z-index: 2;
                                }
                                img{
                                    width: 100%;
                                }
                            }
                        }
						.fliesed{
						    width: 400px;
						    height: 180px;
						    .positive{
						        width: 400px;
						        height: 180px;
						        background: rgba(45, 153, 255, 0.3);
						        position: relative;
						        &:before{
						            content: '';
						            width: 70px;
						            height: 65px;
						         //   background: url("../../../assets/images/upLoad_04.png") no-repeat;
						            background-size: cover;
						            position: absolute;
						            top: 50%;
						            left: 50%;
						            margin-left: -35px;
						            margin-top: -32.5px;
						            z-index: 1;
						        }
						        &:after{
						            content: '';
						            width: 41px;
						            height: 41px;
						       //     background: url("../../../assets/images/upLoad_02.png") no-repeat;
						            background-size: cover;
						            position: absolute;
						            top: 50%;
						            left: 50%;
						            margin-left: -20.5px;
						            margin-top: -20.5px;
						            z-index: 2;
						        }
						        img{
						            width: 100%;
						        }
						    }
						}
                    }
                    .pos{
                        position: absolute;
                        right: 3%;
                        top: 0;
                    }
                }
                .three_btns{
                    justify-content: left;
                    margin: 0 0 0 25%;
                    .el-button{
                        width: 310px;
                        height: 48px;
                    }
                }
                .marBot{
                    float: right;
                    margin-bottom: 26px;
                }
                .my_table{
                    .tdCell{
                        padding: 0 50px;
                        text-align: left;
                        span{
                            color: #C7D7DE;
                            font-size: 18px;
                            i{
                                color: #2D99FF;
                                cursor: pointer;
                                padding-left: 5px;
                            }
                        }
                    }
                }
                .wx_option{
                    padding-left: 25%;
                    h6{
                        font-size: 20px;
                        font-weight: 400;
                        color: #FFFFFF;
                        padding: 42px 0;
                    }
                    .el-checkbox{
                        display: block;
                        margin-bottom: 25px;
                        .el-checkbox__inner{
                            zoom: 180%;
                        }
                        .el-checkbox__label{
                            font-size: 18px;
                            font-weight: 400;
                            color: #FFFFFF;
                            .el-input{
                                width: 660px;
                                .el-input__inner{
                                    height: 24px;
                                    line-height: 24px;
                                    font-size: 14px;
                                    color: #fff;
                                }
                            }

                        }
                    }
                }
            }
        }
    }
</style>
